/**
 * ZD-3331 : 메일 창 발신 주소 후보 목록.
 * - 기본 주소(email_address)는 형식 판정 없이 항상 첫 후보다. 지금 발송에 쓰는 값이므로 기본 선택값이 바뀌지 않는다.
 * - 추가 주소(email_address_extra)는 쉼표로 나눠 trim 하고 빈 항목만 뺀다.
 * - 주소 형식으로는 거르지 않는다. 형식 판정은 서버만 한다('+' 주소 등 서버가 받는 주소를 화면에서 빼지 않기 위해).
 * - 대소문자 무시로 중복을 빼고 먼저 나온 표기를 남긴다.
 */
export function buildSendAddressList(default_value, extra_value) {
	const address_list = [];
	const pushUnique = value => {
		const address = value == null ? '' : String(value).trim();
		if (!address) return;
		if (address_list.some(e => e.toLowerCase() === address.toLowerCase())) return;
		address_list.push(address);
	};

	pushUnique(default_value);
	const extra_list = extra_value == null ? [] : String(extra_value).split(',');
	extra_list.forEach(pushUnique);
	return address_list;
}

/**
 * ZD-3331 2차 : 메일 창 기본 발신 주소.
 * - 로그인 사용자의 Email(User Information)이 후보 중 하나와 같으면(앞뒤 공백·대소문자 무시) 그 후보의 등록 표기를 고른다.
 * - 같지 않거나 비어 있으면 첫 후보(회사 기본 주소)다.
 * - 사용자 Email 을 후보에 새로 넣지 않는다. 보낼 수 있는 주소는 회사 등록 목록뿐이다(서버도 같은 기준으로 확인).
 */
export function pickDefaultSendAddress(address_list, user_email) {
	if (!address_list || address_list.length === 0) return null;
	const email = user_email == null ? '' : String(user_email).trim();
	const matched = email ? address_list.find(address => address.toLowerCase() === email.toLowerCase()) : undefined;
	return matched || address_list[0];
}
